<template>
  <div class="relative" :style="`background-color: ${backgroundColor}`">
    <div class="loader" v-if="iframeLoading" :style="`background-color:${backgroundColor};`">
      <UtilLoader isLoading :loadingText="customLoadingText" class="loader-indicator" />
    </div>

    <iframe
      v-if="iframeSrc"
      :src="iframeSrc"
      @load="loaded()"
      :class="targetClass || 'iframe'"
      :style="{ 'min-height': `${compIframeMinHeight}px` }"
      allowfullscreen
      :loading="lazyLoad ? 'lazy' : undefined"
    />
  </div>
</template>

<script>
import UtilLoader from '@/components/utils/UtilLoader'

export default {
  name: 'UtilIframe',
  components: {
    UtilLoader
  },
  props: {
    url: String,
    loadingText: String,
    passToken: Boolean,
    passPath: Boolean,
    passApplicationId: Boolean,
    iframeMinHeight: {
      type: Number,
      default: 1
    },
    targetClass: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#FFF'
    },
    pathExtras: String,
    lazyLoad: Boolean
  },
  data() {
    return {
      iframeUrl: null,
      iframeSrc: null,
      iframeLoading: true,
      setiframeMinHeight: 0,
      customLoadingText: null
    }
  },
  created() {
    this.iframeUrl = new URL(this.compIframeUrl)
    this.customLoadingText = this.loadingText || this.$t('feedback.loading')
  },
  mounted() {
    this.iframeUrl.searchParams.append('background', this.backgroundColor)

    if (this.passToken && this.appIs.auth) {
      this.iframeUrl.searchParams.append('token', this.$store.state.auth.token)
    }

    if (this.passPath) {
      this.iframeUrl.searchParams.append('path', `${this.$route.fullPath}${this.pathExtras}`)
    }

    if (this.passApplicationId) {
      // TODO: Put this in env config?
      this.iframeUrl.searchParams.append('application', '5ecfcc7f5199950d519a9ed8')
    }

    this.iframeSrc = this.iframeUrl.toString()

    window.addEventListener('message', this.handleIframeEvent)
  },
  destroyed() {
    window.removeEventListener('message', this.handleIframeEvent)
  },
  computed: {
    compIframeUrl() {
      return this.url.includes('http') ? this.url : `${this.assetBaseUrl.hostedPage}${this.url}`
    },

    compIframeMinHeight() {
      if (this.setiframeMinHeight > this.iframeMinHeight) {
        return this.setiframeMinHeight
      } else {
        return this.iframeMinHeight
      }
    }
  },
  methods: {
    handleIframeEvent(event) {
      // Is window message originating from our iframe
      if (this.iframeUrl.origin !== event.origin) {
        return false
      }

      if (this.appIs.local) {
        console.log('Message from iframe', event.data)
      }

      // We might be sending messages from somewhere else (e.g service worker)
      // Let's ensure it's the data we can do something with
      if (event.data && event.data.eventType) {
        switch (event.data.eventType) {
          case 'resize':
            this.setiframeMinHeight = event.data.height
            break

          case 'close':
            this.$emit('close')
            break
        }
      }
    },

    loaded() {
      this.iframeLoading = false

      this.$emit('loaded')
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  @apply absolute w-full h-full top-0 left-0;
  z-index: 10;

  .loader-indicator {
    position: absolute;
    left: 50%;
    top: 50%;
    min-width: 50%;
    min-height: 100px;
    transform: translate(-50%, -50%);
  }
}

.iframe {
  @apply w-full h-full relative;
}
</style>
